import React from "react";

// Components
import { QuickSearchArticleItemLarge } from "../QuickSearchArticleItem";
import Pagination from "../Pagination/Pagination";

const ProductResults = (props) => {
    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "products" ? "active" : "")}
            id="pills-products"
            role="tabpanel"
            aria-labelledby="pills-products-tab"
        >
            {props.products?.length > 0 ? (
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.productsPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result">
                        {props.products.map((item, i) => {
                            return <QuickSearchArticleItemLarge {...item} key={i} />;
                        })}
                    </ul>
                </>
            ) : (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(ProductResults);
